export const createStringPayload = (queries: string[]): string => queries.map((query) => `${query} { value }`).join(' ');

export const createNestedPayload = (parentKey: string, queries: string[]) => {
  const nestedQueries = createStringPayload(queries);

  return `${parentKey} { _data { ${nestedQueries} } }`;
};
